import { render, staticRenderFns } from "./MoleculePermissionCard.vue?vue&type=template&id=b93c4586&scoped=true&"
import script from "./MoleculePermissionCard.vue?vue&type=script&lang=js&"
export * from "./MoleculePermissionCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePermissionCard.vue?vue&type=style&index=0&id=b93c4586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93c4586",
  null
  
)

export default component.exports